import { createFileRoute } from "@tanstack/react-router";
import Safety from "@/pages/Safety";
import { safetyHead } from "@/lib/route-seo";

export const Route = createFileRoute("/about/safety")({
  head: () => safetyHead(),
  component: Safety,
});
